if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.tintHex
) {
  Object.defineProperty(String.prototype, 'tintHex', {
    value(amount) {
      if (!/^#(?:[0-9a-fA-F]{3}){1,2}$/.test(this)) {
        console.warn(`String.prototype.tintHex was called on a string ("${this}") that was not a valid hex color. This function will return #000000.`);
        return '#000000';
      } else if (
        typeof amount !== 'number'
        || parseFloat(amount) > 1
        || parseFloat(amount) < -1
      ) {
        console.warn(`The sole argument for String.prototype.tintHex should be a number between -1 and 1, with negative numbers darkening the color and positive numbers lightening it. This function will return the original hex color: ${this}`);
        return this;
      }
      const hex = String(this).replace(/[^0-9a-f]/gi, '');
      if (hex.length < 6) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      let rgb = '#', c, i;
      for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i*2,2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * amount)), 255)).toString(16);
        rgb += ('00'+c).substr(c.length);
      }
      return rgb;
    }
  });
}